<template>
    <div>
        <test-template :testName="testName" :testId="testId" :test="test">
            <template #questions>
                <b-card v-if="$store.state.session.user.sex === null" class="neu-card">
                    <h2>{{ $t('tests.gender') }}</h2>
                    <div>
                        <b-row>
                            <b-col xs="12" lg="8" class="px-0 pt-1 px-md-5 pt-md-3 float-right m-auto">
                                <button type="button" class="btn btn-primary w-100" @click="setPatientGender('H')">
                                    <span class="text-center">{{ $t('tests.answers.man') }}</span>
                                </button>
                            </b-col>
                            <b-col xs="12" lg="8" class="px-0 pt-1 px-md-5 pt-md-3 float-right m-auto">
                                <button type="button" class="btn btn-primary w-100" @click="setPatientGender('M')">
                                    <span class="text-center">{{ $t('tests.answers.woman') }}</span>
                                </button>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
                <div v-else>
                    <div v-if="cQ && cQ.type === 'input'">
                        <b-card class="neu-card">
                            <h2>{{ cQ.question }}</h2>
                            <b-row>
                                <b-col class="d-flex justify-content-center">
                                    <div class="d-inline-flex">
                                        <b-row>
                                            <b-col cols="12" sm="12" md="6" lg="6">
                                                <base-input class="inputAnswer" type="number" v-model="getClinicHistoryValue" :placeholder="cQ.placeholderInput" :min="cQ.answer[0].startRange" :max="cQ.answer[cQ.answer.length - 1].endRange">
                                                    <template #append>
                                                        <span>{{ cQ.placeholder }}</span>
                                                    </template>
                                                </base-input>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col v-if="cQ.result!=null && cQ.result!='' && cQ.result >= cQ.answer[0].startRange && cQ.result <= cQ.answer[cQ.answer.length - 1].endRange" xs="12" lg="8" class="px-0 pt-1 px-md-5 pt-md-3 float-right m-auto">
                                    <transition name="fade" appear>
                                        <button type="button" class="btn btn-primary w-100" @click.once="calculateMetricResult()">
                                            <span class="text-center">{{ cQ.result }} {{ cQ.placeholder }}</span>
                                            <span class="float-right m-auto"><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/></span>
                                        </button>
                                    </transition>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                    <div v-else-if="cQ && cQ.type === 'double-input'">
                        <b-card class="neu-card">
                            <h2>{{ cQ.question }}</h2>
                            <b-row>
                                <b-col class="d-flex justify-content-center">
                                    <div class="d-inline-flex">
                                        <b-row>
                                            <b-col cols="12" sm="12" md="6" lg="6">
                                                <base-input class="inputAnswer" type="number" v-model="highPressure" :placeholder="'SYS'" :min="cQ.answer[0].startRangeMax" :max="cQ.answer[cQ.answer.length - 1].endRangeMax">
                                                    <template #append>
                                                        <span>{{ cQ.placeholder }}</span>
                                                    </template>
                                                </base-input>
                                            </b-col>
                                            <b-col cols="12" sm="12" md="6" lg="6">
                                                <base-input class="inputAnswer" type="number" v-model="lowPressure" :placeholder="'DIA'" :min="cQ.answer[0].startRangeMin" :max="cQ.answer[cQ.answer.length - 1].endRangeMin">
                                                    <template #append>
                                                        <span>{{ cQ.placeholder }}</span>
                                                    </template>
                                                </base-input>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col v-if="highPressure != null && lowPressure != null && (highPressure >= cQ.answer[0].startRangeMax && highPressure <= cQ.answer[cQ.answer.length - 1].endRangeMax) && (lowPressure >= cQ.answer[0].startRangeMin && lowPressure <= cQ.answer[cQ.answer.length - 1].endRangeMin)" xs="12" lg="8" class="px-0 pt-1 px-md-5 pt-md-3 float-right m-auto">
                                    <transition name="fade" appear>
                                        <button type="button" class="btn btn-primary w-100" @click.once="calculateBloodPressureResult()">
                                            <span class="text-center">{{ highPressure }}/{{ lowPressure }} {{ cQ.placeholder }}</span>
                                            <span class="float-right m-auto"><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/></span>
                                        </button>
                                    </transition>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                    <div v-else>
                        <question-card labelsEnabled :question="cQ" v-model="questionResult" :progress="$store.state.tests.currentSlide" stacked :questionnaireLength="$store.state.tests.test.length"  @answerQuestion="() => { $store.commit('tests/incrementSlide') }" @submitQuestionnaire="saveTestResults"></question-card>
                    </div>
                </div>
            </template>
            <template #results>
                <div key="topGraph" class="first">
                        <h3 class="subtitle-card text-center">{{ $t('tests.testResults') }} - {{ testName.toUpperCase() }}</h3>
                        <column-chart :lastYearResults="$store.state.tests.previousTestResults.slice(-12)" :testName="testName" :customChart="chartValues"></column-chart>
                    </div>
                    <div key="recapCard" class="second">
                        <h4>{{ $t('tests.results') }} {{ month }}</h4>
                        <b-card class="neu-card mean-result col-lg-7">
                            <h3 class="subtitle-card"> {{ testName }}</h3>
                            <h5 class="subtitle-card" :style="`color: ${resultInfo.color}`"> {{ $t(resultInfo.tag).toUpperCase() }}</h5>
                            <p class="p-white" v-html="$t(`tests.cardiovascular-risk.scores.${resultInfo.risk}.description`)"></p>
                        </b-card>
                    </div>
                    <div key="tips" class="mt-5" v-if="resultInfo.risk != 'lowRisk'">
                    <h4>{{ $t('tests.tips') }}</h4>
                    <b-row class="mt-3">
                        <b-row v-for="n in 4" :key="n" class="col-lg-12 results-card px-2">
                                <b-card class="neu-card">
                                    <span class="card-text text-justify" v-html="$t(`tests.cardiovascular-risk.scores.${resultInfo.risk}.tips.tip${n}`)"></span>
                                </b-card>
                        </b-row>
                    </b-row>
                </div>
            </template>
        </test-template>
    </div>
</template>

<script>
import TestTemplate from './TestTemplate.vue'
import { Chart } from 'highcharts-vue'
import selfEvaluationTestMixin from '@/mixins/selfEvaluationTest.mixin'
import BaseRadioGroup from '@/components/base/forms/BaseRadioGroup.vue'
import { GRAY_COLOUR } from '@/constants/colours'
import { TEST_CARDIOVASCULAR_RISK } from '@/constants/patientServices'
import PatientsRepository from '@/repositories/PatientsRepository'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'

export default {
    mixins: [selfEvaluationTestMixin],
    components: {
        'test-template': TestTemplate,
        'highcharts': Chart,
        'column-chart': () => import('@/components/charts/ColumnChart.vue'),
        'radio-button': BaseRadioGroup
    },
    data () {
        var ageValues = [
            { startRange: 18, endRange: 34, man: -1, woman: -9 },
            { startRange: 35, endRange: 39, man: 0, woman: -4 },
            { startRange: 40, endRange: 44, man: 1, woman: 0 },
            { startRange: 45, endRange: 49, man: 2, woman: 3 },
            { startRange: 50, endRange: 54, man: 3, woman: 6 },
            { startRange: 55, endRange: 59, man: 4, woman: 7 },
            { startRange: 60, endRange: 64, man: 5, woman: 8 },
            { startRange: 65, endRange: 69, man: 6, woman: 8 },
            { startRange: 70, endRange: 100, man: 7, woman: 8 }
        ]
        var test = [
            {
                id: 'q1',
                question: this.$t('tests.cardiovascular-risk.questions.q1'),
                placeholderInput: this.$t('tests.cardiovascular-risk.questions.q1'),
                type: 'input',
                answer: ageValues,
                placeholder: this.$t('years'),
                result: null
            },
            {
                id: 'q2',
                question: this.$t('tests.cardiovascular-risk.questions.q2'),
                type: 'radio',
                answer: this.userIsMale ? [
                    {value: 0, text: this.$t('tests.answers.no')},
                    {value: 2, text: this.$t('tests.answers.yes')}
                ] : [
                    {value: 0, text: this.$t('tests.answers.no')},
                    {value: 4, text: this.$t('tests.answers.yes')}
                ],
                result: null
            },
            {
                id: 'q3',
                question: this.$t('tests.cardiovascular-risk.questions.q3'),
                type: 'radio',
                answer: this.userIsMale ? [
                    {value: 0, text: this.$t('tests.answers.no')},
                    {value: 2, text: this.$t('tests.answers.yes')}
                ] : [
                    {value: 0, text: this.$t('tests.answers.no')},
                    {value: 2, text: this.$t('tests.answers.yes')}
                ],
                result: null
            },
            {
                id: 'q4',
                question: this.$t('tests.cardiovascular-risk.questions.q4'),
                placeholderInput: 'Total',
                type: 'input',
                answer: [
                    { startRange: 0, endRange: 159, man: -3, woman: -2 },
                    { startRange: 160, endRange: 199, man: 0, woman: -0 },
                    { startRange: 200, endRange: 239, man: 1, woman: 1 },
                    { startRange: 240, endRange: 279, man: 2, woman: 1 },
                    { startRange: 280, endRange: 1000, man: 3, woman: 3 }
                ],
                placeholder: 'mg/dl',
                result: null
            },
            {
                id: 'q5',
                question: this.$t('tests.cardiovascular-risk.questions.q5'),
                placeholderInput: 'HDL',
                type: 'input',
                answer: [
                    { startRange: 0, endRange: 34, man: 2, woman: 5 },
                    { startRange: 35, endRange: 44, man: 1, woman: 2 },
                    { startRange: 45, endRange: 49, man: 0, woman: 1 },
                    { startRange: 50, endRange: 59, man: 0, woman: 0 },
                    { startRange: 60, endRange: 500, man: -2, woman: -3 }
                ],
                placeholder: 'mg/dl',
                result: null
            },
            {
                id: 'q6',
                question: this.$t('tests.cardiovascular-risk.questions.q6'),
                type: 'double-input',
                answer: [
                    { startRangeMax: 60, endRangeMax: 119, startRangeMin: 20, endRangeMin: 79, man: 0, woman: -3 },
                    { startRangeMax: 120, endRangeMax: 129, startRangeMin: 80, endRangeMin: 84, man: 0, woman: 0 },
                    { startRangeMax: 130, endRangeMax: 139, startRangeMin: 85, endRangeMin: 89, man: 1, woman: 0 },
                    { startRangeMax: 140, endRangeMax: 159, startRangeMin: 90, endRangeMin: 99, man: 2, woman: 2 },
                    { startRangeMax: 160, endRangeMax: 300, startRangeMin: 100, endRangeMin: 300, man: 3, woman: 3 }
                ],
                placeholder: 'mm/hg',
                result: null
            }
        ]
        const chartValues = {
            yAxis: {
                    title: null,
                    max: 53,
                    tickInterval: 15,
                    gridLineWidth: 0.4,
                    gridLineColor: GRAY_COLOUR
                }
        }

        return {
            test: test,
            ageValues: ageValues,
            testId: TEST_CARDIOVASCULAR_RISK,
            testName: this.$t('tests.cardiovascular-risk.title'),
            chartValues: chartValues,
            hdlCholesterol: null,
            ldlCholesterol: null,
            highPressure: null,
            lowPressure: null,
            triglycerides: null,
            totalCholesterol: null
        }
    },
    created () {
        if (this.$store.state.session.user.age !== -1) {
            this.test.shift()
        }
        this.clinicHistoryRepository.getAllVariables().then((r) => {
            this.hdlCholesterol = r.data.data.basicVariables.hdl.values[0]
            this.ldlCholesterol = r.data.data.basicVariables.ldl.values[0]
            this.triglycerides = r.data.data.basicVariables.triglycerides.values[0]
            var bloodPressure = r.data.data.basicVariables.presure.values[0].split('/')
            this.highPressure = bloodPressure[0] === '' ? null : bloodPressure[0]
            this.lowPressure = bloodPressure[1] === '' ? null : bloodPressure[1]
            this.calculateCholesterol()
        })
    },
    methods: {
        calculateCholesterol () {
            if (this.ldlCholesterol && this.hdlCholesterol && this.triglycerides) {
                this.totalCholesterol = this.ldlCholesterol + this.hdlCholesterol + Math.round(this.triglycerides / 5)
            } else {
                this.totalCholesterol = null
            }
        },
        saveTestResults () {
            const results = [
                { points: -2, man: 2, woman: 1 },
                { points: -1, man: 2, woman: 2 },
                { points: 0, man: 3, woman: 2 },
                { points: 1, man: 3, woman: 2 },
                { points: 2, man: 4, woman: 3 },
                { points: 3, man: 5, woman: 3 },
                { points: 4, man: 7, woman: 4 },
                { points: 5, man: 8, woman: 4 },
                { points: 6, man: 10, woman: 5 },
                { points: 7, man: 13, woman: 6 },
                { points: 8, man: 16, woman: 7 },
                { points: 9, man: 20, woman: 8 },
                { points: 10, man: 25, woman: 10 },
                { points: 11, man: 31, woman: 11 },
                { points: 12, man: 37, woman: 13 },
                { points: 13, man: 45, woman: 15 },
                { points: 14, man: 53, woman: 18 },
                { points: 15, man: 53, woman: 20 },
                { points: 16, man: 53, woman: 24 },
                { points: 17, man: 53, woman: 27 }
            ]
            var points = this.test.map(x => x.result).reduce((acc, n) => acc + n, 0) + this.calculateAgeResult()
            const res = results.find(item => item.points === points)
            var percent
            if (res) {
                percent = this.userIsMale ? res.man : res.woman
            } else if (points < -2) {
                percent = this.userIsMale ? 1 : 1
            } else {
                percent = this.userIsMale ? 53 : 27
            }
            this.save(null, percent, this.percentResult(percent, 53))
        },
        calculateMetricResult () {
            if (this.cQ.id === 'q5') {
                this.setVariableValue('hdl', [this.cQ.result])
            }
            var selectedAnswer = this.cQ.answer.find(item => this.cQ.result >= item.startRange && this.cQ.result <= item.endRange)
            if (!selectedAnswer) {
                selectedAnswer = this.cQ.result < this.cQ.answer[0].startRange ? this.cQ.answer[0] : this.cQ.answer[this.cQ.answer.length - 1]
            }
            this.cQ.result = this.userIsMale ? selectedAnswer.man : selectedAnswer.woman
            if (this.$store.state.tests.currentSlide <= this.test.length - 2) {
                this.$store.commit('tests/incrementSlide')
            } else {
                this.saveTestResults()
            }
        },
        calculateBloodPressureResult () {
            this.setVariableValue('presure', [`${this.highPressure}/${this.lowPressure}`])
            var index = Math.max(this.cQ.answer.indexOf(this.cQ.answer.find(item => this.highPressure >= item.startRangeMax && this.highPressure <= item.endRangeMax)), this.cQ.answer.indexOf(this.cQ.answer.find(item => this.lowPressure >= item.startRangeMin && this.lowPressure <= item.endRangeMin)))
            var answer = this.cQ.answer[index]
            this.cQ.result = this.userIsMale ? answer.man : answer.woman
            if (this.$store.state.tests.currentSlide <= this.test.length - 2) {
                this.$store.commit('tests/incrementSlide')
            } else {
                this.saveTestResults()
            }
        },
        setPatientGender (sex) {
            this.$store.state.session.user.sex = sex
            PatientsRepository.updatePatientPersonalData({'sexo': sex}, this.$store.state.session.user.id)
        },
        setVariableValue (name, value) {
            var data = { aspNetUserId: this.$store.state.session.user.id, datetime: new Date(), id: null, petId: null, trackingCreated: false, values: value, variableName: name }
            this.clinicHistoryRepository.saveVariableValue(data)
        },
        calculateAgeResult () {
            var age = this.$store.state.session.user.age
            if (age === -1) return 0
            var agePoints = this.ageValues.find(item => age >= item.startRange && age <= item.endRange)
            if (!agePoints) {
                agePoints = age < this.ageValues[0].startRange ? this.ageValues[0] : this.ageValues[this.ageValues.length - 1]
            }
            return this.userIsMale ? agePoints.man : agePoints.woman
        }
    },
    computed: {
        clinicHistoryRepository () {
            return ClinicHistoryRepository(this.$route.query)
        },
        userIsMale () {
            return this.$store.getters['session/userIsMale']
        },
        getClinicHistoryValue: {
            get () {
                this.cQ.result = this.cQ.id === 'q4' ? this.totalCholesterol : this.cQ.id === 'q5' ? this.hdlCholesterol : this.cQ.result
                return this.cQ.result
            },
            set (newVal) {
                this.cQ.result = newVal
                if (this.cQ.id === 'q4') {
                    this.totalCholesterol = newVal
                } else if (this.cQ.id === 'q5') {
                    this.hdlCholesterol = newVal
                }
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/views/selfEvaluationTests/CardiovascularRiskTest.vue